<template>
  <div :class="{ box: !nobox, nobox: nobox, nocollapse: !collapsible }" class="collapsibleBox">
    <h3
      v-if="!notitle"
      :class="[{ arrowTitle: collapsible, normalTitle: !collapsible }, title]"
      @click="collapseSwitch"
    >
      <img v-if="collapsible" :src="dropdownSrc" class="icon arrow" /><slot name="title" />
    </h3>
    <div v-if="initiated" v-show="!collapsed || !collapsible" class="boxContent">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    collapsible: {
      type: Boolean,
      default: true
    },

    nobox: {
      type: Boolean,
      default: false
    },

    defcollapsed: {
      type: Boolean,
      default: true
    },

    notitle: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      required: false,
      default: ""
    }
  },

  data() {
    return {
      collapsed: true,
      initiated: false
    };
  },

  created() {
    if (!this.collapsible || this.defcollapsed == false) {
      this.collapseSwitch();
    }
  },

  computed: {
    dropdownSrc() {
      return this.collapsed ? `/assets/icons/right.png` : `/assets/icons/down.png`;
    }
  },

  methods: {
    collapseSwitch() {
      this.collapsed = !this.collapsed;
      this.initiated = true;
      if (this.collapsed == false) {
        this.$emit("open");
      } else {
        this.$emit("close");
      }
    }
  }
};
</script>
<style scoped lang="scss">
.arrowTitle {
  cursor: pointer;
  img.arrow {
    vertical-align: middle;
    margin-right: 7px;
  }
}

.normalTitle {
  position: relative;
  padding-top: 10px;
  margin-left: 10px;
}
h3 {
  font-size: 16px;
}

.collapsibleBox.box {
  padding: 0px !important;
}

.boxContent {
  padding: 5px;
}

.nobox > .boxContent {
  padding: 0px;
}
</style>
